import { LegalPageRenderer } from "../components/legal/LegalPageRenderer";
import { TERMS } from "../data/legal";

export function TermsPage() {
  return <LegalPageRenderer content={TERMS} />;
}
